// Config-driven route/menu visibility.
//
// Most `enableForConfig` flags are opt-IN: the route stays hidden until the backend/admin
// turns them on (a missing/false value => hidden).
//
// A few are opt-OUT: default VISIBLE, hidden ONLY when the admin explicitly sets `false`.
// These must stay visible even when the flag is ABSENT — e.g. a user who logged in before
// the field existed still has a persisted `orderConversionDetails` without it (fetchReportData
// only runs at login), or a backend that doesn't return the field yet. Treating "absent" as
// hidden 401'd those users; treating it as visible (only `=== false` hides) is the intent.
export const OPT_OUT_CONFIG_KEYS = new Set([
    'channelOrdersVisibleMerchantPanel',
    'returnsVisibleMerchantPanel',
    'showRvpQcToMerchant',
])

export function isConfigRouteVisible(configKey, orderConversionDetails) {
    if (!configKey) return true
    if (OPT_OUT_CONFIG_KEYS.has(configKey)) {
        // default visible; only an explicit false (admin toggled off) hides it
        return orderConversionDetails?.[configKey] !== false
    }
    // opt-in: hidden until explicitly enabled
    return !!orderConversionDetails?.[configKey]
}
